module.exports = __webpack_public_path__ + "img/3-1.8fa0af6d.jpg";